import { useT } from '../i18n';
import { SORTIERARTEN, type Sortierart } from '../domain/candidateSort';
import styles from './SortierWahl.module.css';

/**
 * Die Ordnung der Prüflingsliste — **ein** Bauteil für beide Stellen, an denen Prüflinge
 * ausgewählt werden: die Prüflingsliste (`CandidatesSheet`) und den Startdialog
 * (`CandidatePickDialog`). Vorher gab es sie nur an der ersten, und die zweite war
 * unsortiert (gemeldet vom Nutzer, 2026-09-13).
 *
 * ⚠️ **Wörter, keine Zeichen.** Der Font trägt nichts, was „Nachname" von „Vorname" oder
 * „Matrikelnr." von „Prüfungsnr." unterscheidet — zwei Paare wären nicht auseinanderzuhalten.
 * Kompakt wird die Leiste stattdessen dadurch, dass die Überschrift „Sortieren" entfällt und
 * die Chips sich die Breite teilen (Entscheidung des Nutzers, 2026-09-13).
 */
export function SortierWahl({
  wert,
  onWahl,
}: {
  wert: Sortierart;
  onWahl: (art: Sortierart) => void;
}) {
  const t = useT();
  return (
    <div className={styles.reihe} role="group" aria-label={t.candidates.sortBy}>
      {SORTIERARTEN.map((art) => (
        <button
          key={art}
          type="button"
          className={`tap ${styles.chip}`}
          data-on={wert === art}
          onClick={() => onWahl(art)}
        >
          {t.candidates.sort[art]}
        </button>
      ))}
    </div>
  );
}
